import thingsToDoMap from './modules/thingsToDoMap.js';

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Hotel Booking Form onSubmit
    // $ ('.hotel-booking-form').submit(function(e) {
    //   if ($(this).find('input.check-in').val().toLowerCase() === '' ||
    //     $(this).find('input.check-out').val().toLowerCase() === '') {
    //     $(this).find('.date-validator').show();
    //     e.preventDefault();
    //   } else {
    //     $(this).find('.date-validator').hide();
    //   }
    // });

    const localTipWrapper = $('.local-tip-wrapper');
    const localTipSlider = localTipWrapper.find('.slider');
    if (localTipSlider.length) {
      const localTipDots = localTipWrapper.find('.slider-dots');

      localTipSlider.slick({
        arrows: false,
        dots: true,
        speed: 300,
        slidesToShow: 1,
        infinite: false,
        appendDots: localTipDots,
        customPaging: function(slider, i) {
          return `<div class="thumb">${ i + 1 }</div>`;
        },
      });
    }

    thingsToDoMap();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelThingsToDo.js